import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To capture custom events, evaluate feature flags, and use any of the other PostHog features, you can use the `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` object returned from the `}<inlineCode parentName="p">{`usePostHog`}</inlineCode>{` composable like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/App.vue
<script setup>
import { RouterView } from 'vue-router'
import { usePostHog } from './composables/usePostHog'

const { posthog } = usePostHog()

const handleClick = () => {
  posthog.capture('button_clicked', { location: 'homepage' })
}

const isFeatureEnabled = posthog.isFeatureEnabled('test-flag')
</script>

<template>
  <div>
    <button @click="handleClick">Click me!</button>
    <p>Is feature flag enabled? {{ isFeatureEnabled ? 'Yes' : 'No' }}</p>
  </div>

  <RouterView />
</template>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      